// extracted by mini-css-extract-plugin
module.exports = {"navbar":"categoriesHeader_navbar__cbZjt","logo":"categoriesHeader_logo__ZIOIv","link":"categoriesHeader_link__1Mjrg","active":"categoriesHeader_active__3iV9V"};